module.exports = __webpack_public_path__ + "img/2.2.2B.aad461c3.jpg";